import {
  CAMPAIGN_LIST_LOADING,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_LIST_FAILURE,
} from "redux/types";

const initialState = {
  campaignListLoading: false,
  campaignList: null,
  errors: null,
};

export const campaignListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CAMPAIGN_LIST_LOADING:
      return { ...state, campaignListLoading: action.payload };
    case CAMPAIGN_LIST_SUCCESS:
      return { ...state, campaignList: action.payload };
    case CAMPAIGN_LIST_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
